import React from 'react';

import { Popover as MuiPopover, Box, SxProps, Theme, PopoverOrigin } from '@mui/material';

interface PopoverProps {
  trigger: React.ReactElement;
  children: React.ReactNode;
  open: boolean;
  onOpen: (event: React.MouseEvent<HTMLElement>) => void;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  container?: HTMLElement | null;
  sx?: SxProps<Theme>;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

const Popover = ({
  trigger,
  children,
  open,
  onOpen,
  onClose,
  anchorEl,
  container,
  sx,
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
  ...props
}: PopoverProps) => {
  const id = open ? 'interactive-tooltip' : undefined;

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: onOpen,
        'aria-describedby': id
      })}

      <MuiPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        container={container}
        onClose={onClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        {...props}
      >
        <Box sx={{ p: 2, ...sx }}>{children}</Box>
      </MuiPopover>
    </>
  );
};

export default Popover;
